"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.tutorial.list': 'Tutorials',
};
